function Slovenia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2123)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.0048 10.4347H13.9131V6.26074H5.56519V10.4347H0.995188C0.352063 12.1679 0 14.0427 0 15.9999C0 17.957 0.352063 19.8317 0.995188 21.565L16 22.9564L31.0048 21.565C31.6479 19.8317 32 17.957 32 15.9999C32 14.0427 31.6479 12.1679 31.0048 10.4347Z" fill="#0052B4"/>
  <path d="M16 32.0002C22.8795 32.0002 28.7442 27.6582 31.0049 21.5654H0.995239C3.25593 27.6582 9.12061 32.0002 16 32.0002Z" fill="#D80027"/>
  <path d="M5.56519 10.4349V11.8261C5.56519 15.0212 9.73912 16.0001 9.73912 16.0001C9.73912 16.0001 13.9131 15.0212 13.9131 11.8261V10.4349L12.5217 11.8262L9.73912 9.73926L6.9565 11.8262L5.56519 10.4349Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Slovenia;
